<template>
  <div>
    <div style="border-top: 0.1rem solid #ededed;"></div>
    <div class="lastComments">
      <div class="last_top" >
        <div class="lastLogo">最新评论</div>
      </div>
      <commentContent :items="lastComments" :govImage="govImage"></commentContent>
    </div>
  </div>

</template>
<script>
  import utils from '../../tool/utils'
  import commentContent from './commentContent'
  export default{
    props: ['lastComments', 'govImage'],
    mounted () {
    },
    filters: {
      parseDateTime: function (t) {
        return utils.parseDateTime(t)
      },
      parseSpace: function (t) {
        return utils.parseSpace(t)
      },
      parseCount: function (t) {
        return utils.parseCount(t)
      }
    },
    components: {
      commentContent
    }
  }
</script>
<style scoped>
  .lastComments {
    margin: 0.4rem 0.3rem 0;
  }
  .last_top {
    width: 100%;
    /*height:0.5rem;*/
    overflow: hidden;
  }
  .lastLogo{
    height: 0.3rem;
    line-height: 0.3rem;
    font-size: 0.3rem;
    border-left: 0.04rem solid var(--themeColor);
    padding-left: 0.1rem;
  }

</style>



// WEBPACK FOOTER //
// lastComments.vue?9b6e3e54